// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9h-3";
export var contentContainer = "_9h-0";
export var editorContainer = "_9h-1";
export var quillInputForm = "_9h-2";
export var zoneDivider = "_9h-4";